export const TABLEAU_URL = 'https://dub01.online.tableau.com#/site/intersocialserver/'
export const TABLEAU_MUTATION_LOG_DASHBOARD = TABLEAU_URL + 'views/MutationLog/MutationLog'
export const TABLEAU_MUTATION_LOG_MAX_INTERVAL_DAYS = 7